/* Dikke Bieren: succes-state "Toegevoegd ✓" op koopknoppen na AJAX add-to-cart
   (productkaarten, productpagina en de mobiele koopbalk die via form= aan het formulier hangt). */
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event.source !== 'product-form' || !event.productVariantId) return;
  document
    .querySelectorAll(`product-form input[name="id"][value="${event.productVariantId}"]`)
    .forEach((input) => {
      const form = input.closest('form');
      if (!form) return;
      /* getAttribute: form.id geeft hier het veld name="id" terug, niet het attribuut */
      const formId = form.getAttribute('id');
      const buttons = [
        form.querySelector('[type="submit"]'),
        ...(formId ? document.querySelectorAll(`button[form="${formId}"]`) : []),
      ].filter(Boolean);
      buttons.forEach((btn) => {
        const span = btn.querySelector('span');
        if (!span) return;
        if (!btn.dataset.dbLabel) btn.dataset.dbLabel = span.innerHTML; /* innerHTML: de +-knop heeft een svg */
        clearTimeout(btn.dbAddedTimer); /* herhaald tikken: timer reset */
        btn.classList.add('db-added');
        span.textContent = btn.dataset.dbAdded || 'Toegevoegd ✓';
        btn.dbAddedTimer = setTimeout(() => {
          btn.classList.remove('db-added');
          span.innerHTML = btn.dataset.dbLabel;
        }, 1600);
      });
    });
});

/* Dikke Bieren: statiegeld (issue #94, ADR-0007). Het product "Statiegeld" hoort in de winkelwagen te staan met
   het aantal dat snippets/statiegeld-data.liquid uitrekent ("nodig~huidig~variant~prijs~aantal"). Dat staat als
   data-statiegeld in de sectie cart-icon-bubble, die in elk antwoord op een winkelwagenwijziging meekomt (add,
   change, Standard Actions), dus er is geen extra verzoek nodig. Updates gaan in een rij en zijn absoluut: de
   laatste stand wint.
   ponytail: dat gaat uit van events in serververvolgorde; twee gelijktijdige adds die andersom terugkomen laten
   een oud aantal staan tot de volgende wijziging of paginalading. Er wordt geen cartUpdate gepubliceerd (geen lus; CartItems.onCartUpdate vraagt bovendien
   section_id=main-cart-items op, terwijl de sectie in de template cart-items heet). */
let dbStatiegeldRij = Promise.resolve();
let dbStatiegeldBezig = 0;

function dbStatiegeld(html) {
  const el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-statiegeld]');
  if (!el) return;
  const [nodig, huidig, variant] = el.dataset.statiegeld.split('~').map(Number);
  if (!variant || nodig === huidig) return;
  const cartItems = document.querySelector('cart-items');
  const secties = cartItems
    ? cartItems.getSectionsToRender()
    : [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
  dbStatiegeldBezig++;
  dbStatiegeldRij = dbStatiegeldRij
    .then(() =>
      fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates: { [variant]: nodig },
          sections: [...new Set(secties.map((s) => s.section))],
          sections_url: window.location.pathname,
        }),
      })
    )
    .then((response) => response.json())
    .then((state) => {
      if (!state.sections) return;
      /* Zelfde vervanging als CartItems.updateQuantity in assets/cart.js. */
      cartItems?.classList.toggle('is-empty', state.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', state.item_count === 0);
      /* Focus terugzetten zoals cart.js dat doet; de regel-id schuift als het statiegeld erbij komt, de regelsleutel niet. */
      const actief = document.activeElement;
      const sleutel = actief?.closest('quantity-input')?.querySelector('[data-quantity-line-key]')?.dataset.quantityLineKey;
      const naam = actief?.getAttribute('name');
      secties.forEach((s) => {
        const doel = document.getElementById(s.id);
        const bron = state.sections[s.section] && new DOMParser().parseFromString(state.sections[s.section], 'text/html').querySelector(s.selector);
        if (doel && bron) (doel.querySelector(s.selector) || doel).innerHTML = bron.innerHTML;
      });
      if (sleutel && naam) {
        document
          .querySelector(`[data-quantity-line-key="${sleutel}"]`)
          ?.closest('quantity-input')
          ?.querySelector(`[name="${naam}"]`)
          ?.focus();
      }
    })
    /* ponytail: mislukt de update, dan zet de volgende winkelwagenwijziging of paginalading het recht. */
    .catch(() => {})
    .finally(() => dbStatiegeldBezig--);
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => dbStatiegeld(event.cartData?.sections?.['cart-icon-bubble']));
document.addEventListener('DOMContentLoaded', () => dbStatiegeld(document.getElementById('cart-icon-bubble')?.innerHTML));

/* Afrekenen terwijl het statiegeld nog wordt bijgewerkt: eerst die update afwachten. Het winkelwagenformulier kan
   intussen vervangen zijn, dus daarna rechtstreeks naar de checkout.
   ponytail: een aantal wijzigen en afrekenen vóór cart.js zijn antwoord heeft (debounce van 300 ms plus de
   cart/change-roundtrip) valt hier buiten; de knop krijgt tijdens het wachten geen laadstatus. */
document.addEventListener('submit', (event) => {
  if (!dbStatiegeldBezig || event.submitter?.name !== 'checkout') return;
  event.preventDefault();
  dbStatiegeldRij.then(() => {
    window.location.href = '/checkout';
  });
});
